import React, { useEffect, useState } from 'react';
import { ReactComponent as RotateIcon } from 'images/rotateIcon.svg';
import dayjs from 'dayjs';
import {
  DiscrepanciesChip,
  DiscrepanciesText,
  Separator,
  DiscrepanciesWrapper,
  StyledDiscrepanciesIcon,
  TopBarWrapper,
  RefreshButton,
  RefreshWrapper,
  RefreshInfo,
} from './styles/DiscrepanciesBarStyles';

interface IProps {
  discrepancyCount: number;
  onButtonClick: () => void;
}

const TIMESTAMP_KEY = 'refreshTimestamp';

const DiscrepanciesBar: React.FC<IProps> = (props) => {
  const { discrepancyCount, onButtonClick } = props;
  const [lastUpdate, setLastUpdate] = useState<string | null>(null);
  let interval: ReturnType<typeof setInterval>;

  useEffect(() => {
    interval = setInterval(() => {
      const timestamp = localStorage.getItem(TIMESTAMP_KEY);

      if (timestamp) {
        setLastUpdate(dayjs(timestamp).fromNow());
      }
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const onClickHandler = () => {
    onButtonClick();
    localStorage.setItem(TIMESTAMP_KEY, dayjs().toString());
  };

  useEffect(() => {
    localStorage.setItem(TIMESTAMP_KEY, dayjs().toString());
  }, []);

  return (
    <TopBarWrapper>
      <DiscrepanciesWrapper>
        <DiscrepanciesText>Discrepancies</DiscrepanciesText>
        <Separator />
        <DiscrepanciesChip>
          <StyledDiscrepanciesIcon /> {`${discrepancyCount}`}
        </DiscrepanciesChip>
      </DiscrepanciesWrapper>
      <RefreshWrapper>
        {lastUpdate && (
          <RefreshInfo>
            <div>Last updated:</div>
            <div>{lastUpdate}</div>
          </RefreshInfo>
        )}
        <RefreshButton onClick={onClickHandler}>
          <RotateIcon />
        </RefreshButton>
      </RefreshWrapper>
    </TopBarWrapper>
  );
};

export default DiscrepanciesBar;
